const navItemsDropdown = () =>
{

    const header = document.querySelector(".header");
    let navItems = [];

    if (header)
        navItems = header.querySelectorAll(".nav__item");

    navItems.forEach((navItem) =>
    {
        navItem.addEventListener("mouseenter", (event) =>
        {
            const item = event.currentTarget;
            const theme = item.getAttribute("data-nav-theme") || "";

            header.classList.add("header--active");
            header.setAttribute("data-theme", theme);

        });

        navItem.addEventListener("mouseleave", (e) =>
        {
            header.classList.remove("header--active");
            // header.setAttribute("data-theme", "");
            header.removeAttribute("data-theme", "");
        })
    })


    const navItemsLinks = document.querySelectorAll(".nav__item a");

    navItemsLinks.forEach((navItem) =>
    {
        if (navItem.dataset.dropdown)
        {
            navItem.addEventListener("click", (e) =>
            {
                e.preventDefault()
                e.stopPropagation()

                /*
                const assignedDropdown = document.querySelector(
                    `.sub-nav[data-target="${navItem.dataset.dropdown}"]`
                )
                const activeLink = document.querySelector(".nav-link-active")

                if (activeLink)
                {
                    activeLink.classList.remove("nav-link-active")
                }
                navItem.classList.add("nav-link-active")

                document.addEventListener(
                    "click",
                    (event) =>
                    {
                        if (!event.target.closest(".sub-nav"))
                        {
                            closeNavItemDropdown(navItem)
                        }
                    },
                    false
                )*/
            })
        }
    })

    function closeNavItemDropdown(navItem)
    {
        navItem.classList.remove("nav-link-active")
    }
}

export default navItemsDropdown
